import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Opslaan niet mogelijk",
    ohNoSomethingWentWrong: "O nee, er ging iets mis! :(",
    refreshAndTryAgain: "Vernieuw de pagina en probeer het opnieuw.",
    goToLogin: "Naar aanmelden",
};
